<template>
  <ChartWrapper
    v-bind="$props"
    :is-data-empty="isDataEmpty"
    :context="context"
    class="container-gap"
  />
</template>

<script>
import ChartWrapper from '@/modules/core/legacy/charts/am5/base/components/ChartWrapper.vue';
import { createChartContext } from '@/modules/core/legacy/charts/am5/base/composables/createChartContext';
import { isEmpty, isNil } from 'lodash';
import { useMaps } from '@/modules/core/legacy/charts/am5/geo/composables/useGeoChart';
import { WidgetEvents } from '@/modules/core/legacy/charts/am5/charts.constants';
import { BasePropsMixin } from '@/modules/core/legacy/charts/am5/base/mixins/BasePropsMixin';
import { WidgetEvent } from '@/modules/ta/legacy/widget/widget.constants';
import EventBus from '@/modules/core/app/helpers/EventBus';

export default {
  name: 'GeoChart',
  mixins: [BasePropsMixin],
  components: {
    ChartWrapper,
  },
  props: {
    isComparison: {
      type: Boolean,
      default: false,
    },
    help: {
      type: [Object, String],
      default: null,
    },
  },
  mounted() {
    EventBus.listen(`${WidgetEvent.RELOAD_CHART}`, () => {
      this.initMaps;
    });
    this.initMaps;
  },
  setup(props, componentContext) {
    const context = createChartContext(props.config);
    const { refresh, onBind, onFrameEnded } = context();
    const { initMaps } = useMaps(context);

    onBind(() => {
      initMaps();
    });

    onFrameEnded(() => {
      componentContext.emit(WidgetEvents.FRAME_ENDED);
    });

    return {
      context,
      refresh,
    };
  },
  computed: {
    isDataEmpty() {
      return isNil(this.config.data) || isEmpty(this.config.data);
    },
  },
};
</script>
